import React, { useEffect } from 'react';
import { useVeltClient } from '../../context';
import VeltChartComment from '../VeltChartComment';
var VeltNivoChartComments = function (_a) {
    var _b, _c, _d, _e, _f;
    var chartComputedData = _a.chartComputedData, dialogMetadataTemplate = _a.dialogMetadataTemplate, id = _a.id;
    var client = useVeltClient().client;
    var _g = React.useState({ comments: [] }), ghostCommentsData = _g[0], setGhostCommentsData = _g[1];
    var _h = React.useState(null), documentPathsSubscription = _h[0], setDocumentPathsSubscription = _h[1];
    var _j = React.useState(null), commentSubscription = _j[0], setCommentSubscription = _j[1];
    // Unsubscribe from the subscriptions when the component is unmounted
    useEffect(function () {
        return function () {
            unsubscribeDocumentPathsSubscription();
            unsubscribeCommentSubscription();
        };
    }, []);
    useEffect(function () {
        getCommentAnnotations();
    }, [chartComputedData === null || chartComputedData === void 0 ? void 0 : chartComputedData.data]);
    useEffect(function () {
        if (client) {
            getCommentAnnotations();
        }
    }, [client]);
    var getCommentAnnotations = function () {
        var _a;
        try {
            unsubscribeDocumentPathsSubscription();
            unsubscribeCommentSubscription();
            if (client) {
                var subscription = (_a = client === null || client === void 0 ? void 0 : client.docService) === null || _a === void 0 ? void 0 : _a.getDocumentPaths$().subscribe(function (paths) {
                    var _a;
                    if (paths === null || paths === void 0 ? void 0 : paths.clientDocumentId) {
                        unsubscribeCommentSubscription();
                        var commentElement = client.getCommentElement();
                        var subscription_1 = (_a = commentElement === null || commentElement === void 0 ? void 0 : commentElement.getAllCommentAnnotations(paths === null || paths === void 0 ? void 0 : paths.clientDocumentId)) === null || _a === void 0 ? void 0 : _a.subscribe(function (comments) {
                            filterGhostComments(comments);
                        });
                        setCommentSubscription(subscription_1);
                    }
                });
                setDocumentPathsSubscription(subscription);
            }
        }
        catch (err) {
        }
    };
    var filterGhostComments = function (comments) {
        var _a, _b, _c;
        try {
            var chartComments = (_a = comments === null || comments === void 0 ? void 0 : comments.filter(function (annotation) { return annotation.commentType === 'chart'; })) === null || _a === void 0 ? void 0 : _a.filter(function (annotation) { var _a; return ((_a = annotation === null || annotation === void 0 ? void 0 : annotation.metadata) === null || _a === void 0 ? void 0 : _a.id) === id; });
            if ((_b = chartComputedData === null || chartComputedData === void 0 ? void 0 : chartComputedData.bars) === null || _b === void 0 ? void 0 : _b.length) {
                var ghostComments_1 = [];
                chartComments.forEach(function (annotation) {
                    var _a;
                    var metadata = annotation.metadata;
                    var groupId = metadata === null || metadata === void 0 ? void 0 : metadata.groupId;
                    var value = metadata === null || metadata === void 0 ? void 0 : metadata.value;
                    var label = metadata === null || metadata === void 0 ? void 0 : metadata.label;
                    if (groupId && value && label) {
                        var bar = (_a = chartComputedData.bars) === null || _a === void 0 ? void 0 : _a.find(function (bar) { var _a, _b, _c; return ((_a = bar === null || bar === void 0 ? void 0 : bar.data) === null || _a === void 0 ? void 0 : _a.id) === groupId && ((_b = bar === null || bar === void 0 ? void 0 : bar.data) === null || _b === void 0 ? void 0 : _b.value) === value && ((_c = bar === null || bar === void 0 ? void 0 : bar.data) === null || _c === void 0 ? void 0 : _c.indexValue) === label; });
                        if (!bar) {
                            ghostComments_1.push(annotation);
                        }
                    }
                });
                var width = ((_c = chartComputedData === null || chartComputedData === void 0 ? void 0 : chartComputedData.bars[0]) === null || _c === void 0 ? void 0 : _c.width) || 0;
                setGhostCommentsData({ comments: ghostComments_1, width: width, type: 'bar' });
            }
            else if (chartComputedData === null || chartComputedData === void 0 ? void 0 : chartComputedData.points) {
                var ghostComments_2 = [];
                chartComments.forEach(function (annotation) {
                    var _a;
                    var metadata = annotation.metadata;
                    var groupId = metadata === null || metadata === void 0 ? void 0 : metadata.groupId;
                    var value = metadata === null || metadata === void 0 ? void 0 : metadata.value;
                    var label = metadata === null || metadata === void 0 ? void 0 : metadata.label;
                    if (groupId && value && label) {
                        var point = (_a = chartComputedData.points) === null || _a === void 0 ? void 0 : _a.find(function (point) { var _a, _b; return (point === null || point === void 0 ? void 0 : point.serieId) === groupId && ((_a = point === null || point === void 0 ? void 0 : point.data) === null || _a === void 0 ? void 0 : _a.y) === value && ((_b = point === null || point === void 0 ? void 0 : point.data) === null || _b === void 0 ? void 0 : _b.x) === label; });
                        if (!point) {
                            ghostComments_2.push(annotation);
                        }
                    }
                });
                var width = 0;
                setGhostCommentsData({ comments: ghostComments_2, width: width, type: 'line' });
            }
        }
        catch (err) {
        }
    };
    var polarToCartesian = function (centerX, centerY, radius, angleInRadians) {
        return {
            x: centerX + radius * Math.cos(angleInRadians - Math.PI / 2),
            y: centerY + radius * Math.sin(angleInRadians - Math.PI / 2)
        };
    };
    var unsubscribeDocumentPathsSubscription = function () {
        try {
            if (documentPathsSubscription) {
                documentPathsSubscription === null || documentPathsSubscription === void 0 ? void 0 : documentPathsSubscription.unsubscribe();
            }
        }
        catch (err) {
        }
    };
    var unsubscribeCommentSubscription = function () {
        try {
            if (commentSubscription) {
                commentSubscription === null || commentSubscription === void 0 ? void 0 : commentSubscription.unsubscribe();
            }
        }
        catch (err) {
        }
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("foreignObject", null,
            React.createElement("style", null, "\n                        .nivo-chart-comment-point {\n                            opacity: 0 !important;\n                            visibility: hidden !important;\n                          }\n                          \n                          .nivo-chart-comment-tool {\n                            opacity: 0;\n                          }\n                          \n                          .nivo-chart-comment-tool:hover {\n                            opacity: 1;\n                            visibility: visible;\n                            transition: 0.3s;\n                          }\n                          \n                          .nivo-chart-comment-container {\n                            position: relative;\n                            display: flex;\n                            flex-direction: column;\n                            align-items: center;\n                            justify-content: center;\n                            width: 100%;\n                            height: 100%;\n                          }\n                          \n                          .nivo-chart-comment-container velt-comment-tool {\n                            display: flex;\n                            cursor: pointer;\n                          }\n                          \n                          .nivo-chart-container snippyly-comment-pin-portal {\n                              /* hide it */\n                              display: none;\n                          }\n                    ")),
        ((_b = chartComputedData === null || chartComputedData === void 0 ? void 0 : chartComputedData.points) === null || _b === void 0 ? void 0 : _b.length) && chartComputedData.points.map(function (point, index) {
            var _a, _b;
            var commentMetadata = {
                id: id,
                label: (_a = point === null || point === void 0 ? void 0 : point.data) === null || _a === void 0 ? void 0 : _a.x,
                groupId: point === null || point === void 0 ? void 0 : point.serieId,
                value: (_b = point === null || point === void 0 ? void 0 : point.data) === null || _b === void 0 ? void 0 : _b.y,
            };
            return (React.createElement("g", { transform: "translate(".concat(point.x, ", ").concat(point.y, ")"), key: point.id },
                React.createElement("foreignObject", { x: -12, y: -40, width: "24", height: "24" },
                    React.createElement("div", { className: 'nivo-chart-comment-container' },
                        React.createElement(VeltChartComment, { commentMetadata: commentMetadata, dialogMetadataTemplate: dialogMetadataTemplate || ['groupId', 'label', 'value'] })))));
        }),
        ((_c = chartComputedData === null || chartComputedData === void 0 ? void 0 : chartComputedData.bars) === null || _c === void 0 ? void 0 : _c.length) && chartComputedData.bars.map(function (point, index) {
            var _a, _b, _c;
            var commentMetadata = {
                id: id,
                label: (_a = point === null || point === void 0 ? void 0 : point.data) === null || _a === void 0 ? void 0 : _a.indexValue,
                groupId: (_b = point === null || point === void 0 ? void 0 : point.data) === null || _b === void 0 ? void 0 : _b.id,
                value: (_c = point === null || point === void 0 ? void 0 : point.data) === null || _c === void 0 ? void 0 : _c.value,
            };
            return (React.createElement("g", { transform: "translate(".concat(point.x + point.width, ", ").concat(point.y, ")"), key: point.key },
                React.createElement("foreignObject", { x: 0, y: -8, width: "24", height: "24" },
                    React.createElement("div", { className: 'nivo-chart-comment-container' },
                        React.createElement(VeltChartComment, { commentMetadata: commentMetadata, dialogMetadataTemplate: dialogMetadataTemplate || ['groupId', 'label', 'value'] })))));
        }),
        ((_d = chartComputedData === null || chartComputedData === void 0 ? void 0 : chartComputedData.dataWithArc) === null || _d === void 0 ? void 0 : _d.length) && chartComputedData.dataWithArc.map(function (arcData, index) {
            var midAngle = (arcData.arc.startAngle + arcData.arc.endAngle) / 2;
            var radiusOffset = 20; // Extend beyond the outer radius for visibility
            var position = polarToCartesian(chartComputedData.centerX, chartComputedData.centerY, arcData.arc.outerRadius + radiusOffset, midAngle);
            var commentMetadata = {
                id: id,
                label: arcData === null || arcData === void 0 ? void 0 : arcData.label,
                value: arcData === null || arcData === void 0 ? void 0 : arcData.value,
            };
            return (React.createElement("g", { transform: "translate(".concat(position.x, ", ").concat(position.y, ")"), key: arcData.id },
                React.createElement("foreignObject", { width: "100", height: "50", x: "-50", y: "-25", style: { overflow: 'visible' } },
                    React.createElement("div", { className: 'nivo-chart-comment-container' },
                        React.createElement(VeltChartComment, { commentMetadata: commentMetadata, dialogMetadataTemplate: dialogMetadataTemplate || ['label', 'value'] })))));
        }),
        ((_e = ghostCommentsData === null || ghostCommentsData === void 0 ? void 0 : ghostCommentsData.comments) === null || _e === void 0 ? void 0 : _e.length) && ((_f = ghostCommentsData === null || ghostCommentsData === void 0 ? void 0 : ghostCommentsData.comments) === null || _f === void 0 ? void 0 : _f.map(function (annotation) {
            var metadata = annotation.metadata;
            var groupId = metadata === null || metadata === void 0 ? void 0 : metadata.groupId;
            var value = metadata === null || metadata === void 0 ? void 0 : metadata.value;
            var label = metadata === null || metadata === void 0 ? void 0 : metadata.label;
            var x = (chartComputedData === null || chartComputedData === void 0 ? void 0 : chartComputedData.xScale) ? chartComputedData.xScale(label) : 0;
            var y = (chartComputedData === null || chartComputedData === void 0 ? void 0 : chartComputedData.yScale) ? chartComputedData.yScale(value) : 0;
            var point = { x: x, y: y, width: (ghostCommentsData === null || ghostCommentsData === void 0 ? void 0 : ghostCommentsData.width) || 0, key: annotation.annotationId };
            var commentMetadata = {
                id: id,
                label: label,
                groupId: groupId,
                value: value,
            };
            switch (ghostCommentsData === null || ghostCommentsData === void 0 ? void 0 : ghostCommentsData.type) {
                case 'bar':
                    return (React.createElement("g", { transform: "translate(".concat(point.x + point.width, ", ").concat(point.y, ")"), key: point.key },
                        React.createElement("foreignObject", { x: 0, y: -8, width: "24", height: "24" },
                            React.createElement("div", { className: 'nivo-chart-comment-container' },
                                React.createElement(VeltChartComment, { ghostComment: true, commentMetadata: commentMetadata, dialogMetadataTemplate: dialogMetadataTemplate || ['groupId', 'label', 'value'] })))));
                case 'line':
                    return (React.createElement("g", { transform: "translate(".concat(point.x + point.width, ", ").concat(point.y, ")"), key: point.key },
                        React.createElement("foreignObject", { x: -12, y: -48, width: "24", height: "24" },
                            React.createElement("div", { className: 'nivo-chart-comment-container' },
                                React.createElement(VeltChartComment, { ghostComment: true, commentMetadata: commentMetadata, dialogMetadataTemplate: dialogMetadataTemplate || ['groupId', 'label', 'value'] })))));
                default:
                    return null;
            }
        }))));
};
export default VeltNivoChartComments;
